<template>
    <div class="invoiceDetails table-responsive">
        <table class="table table-bordered table-hover">
            <thead>
                <tr>
                    <th>Eta</th>
                    <th>Etd</th>
                    <th>Location From</th>
                    <th>Location To</th>
                    <th>Mode</th>
                    <th>Type</th>
                    <th>Carrier Name</th>
                    <th>Confirmed</th>
                    <th>Agent</th>
                </tr>
            </thead>
            <tbody>
                <template v-if="shipmentDetails.length > 0">
                    <template v-for="(shipment, index) in shipmentDetails">
                        <tr>
                            <td>{{ shipment.eta }}</td>
                            <td>{{ shipment.etd }}</td>
                            <td>{{ shipment.location_from }}</td>
                            <td>{{ shipment.location_to }}</td>
                            <td>{{ shipment.mode }}</td>
                            <td>{{ shipment.type }}</td>
                            <td>{{ shipment.carrier_name }}</td>
                            <td>
                                {{ shipment.is_confirmed == 1 ? "Yes" : "No" }}
                            </td>
                            <td>{{ shipment.agent }}</td>
                        </tr>
                    </template>
                </template>
                <template v-else> No Data found </template>
            </tbody>
        </table>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import axios from "axios";
import ShippingTrackingModal from "./ShippingTrackingModal";

export default {
    name: "OrderShipments",
    props: ["shipmentDetails", "loading", "bus"],
    components: { ShippingTrackingModal },
    mounted() {},
    data() {
        return {
            shippingProductDetailId: null,
            shippingByRefList: null,
            shippingByRef: null,
            shippingStatus: null,
            shipping: null,
        };
    },
    methods: {
        ...mapActions([
            "setCommonErrors",
            "setErrorMessage",
            "setSuccessMessage",
            "setLoading",
        ]),
        toggleShippingProductDetailId(product) {
            if (this.shippingProductDetailId === product.id) {
                this.shippingProductDetailId = null;
            } else {
                this.shippingProductDetailId = product.id;
            }
            this.$emit(
                "toggleShippingProductDetailIdEvent",
                this.shippingProductDetailId
            );
        },
        getShippingQuantityByStatus(product, status) {
            let total = 0;
            if (status) {
                product.shippings
                    .filter((x) => x.status === status)
                    .forEach((x) => {
                        total += x.pivot.quantity;
                    });
            } else {
                product.shippings.forEach((x) => {
                    total += x.pivot.quantity;
                });
            }

            return total;
        },
        getShipmentStatusById(id) {
            let self = this;
            this.shippingStatus = null;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            return axios
                .get(
                    window.route("so.getShipmentStatusById", {
                        id: this.order.id,
                        shipment_id: id,
                    }),
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        //console.log(data.data);
                        this.shippingStatus = data.data.data;

                        $("#shippingTrackingModal").modal("show");
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        getShipmentByRef(shipping, id) {
            this.shipping = _.cloneDeep(shipping);
            let self = this;
            this.shippingStatus = null;
            this.shippingByRefList = null;
            this.shippingByRef = null;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            return axios
                .get(
                    window.route("so.getShipmentByRef", {
                        id: this.order.id,
                        tracking_no: id,
                        type: "BYCONTAINER",
                    }),
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        //console.log(data.data);
                        if (data.data.success) {
                            this.shippingByRefList = _.cloneDeep(
                                data.data.data
                            );
                            let shippings =
                                data.data.data.BYCONTAINER.Active.filter(
                                    (x) => x["MBL#"] == id
                                );
                            if (shippings.length) {
                                this.shippingByRef = _.cloneDeep(shippings[0]);
                                //console.log(shippings[0]['Shifl Ref#'])
                                //console.log(shippings[0]['Shifl Ref#'].substr(1, shippings[0]['Shifl Ref#'].length))
                                //let ship_id = shippings[0]['Shifl Ref#'].substr(1, shippings[0]['Shifl Ref#'].length);
                                //this.getShipmentStatusById(ship_id);
                            } else {
                                shippings =
                                    data.data.data.BYCONTAINER.Completed.filter(
                                        (x) => x["MBL#"] == id
                                    );
                                if (shippings.length) {
                                    this.shippingByRef = _.cloneDeep(
                                        shippings[0]
                                    );
                                    //let ship_id = shippings[0]['Shifl Ref#'].substr(1, shippings[0]['Shifl Ref#'].length);
                                    //this.getShipmentStatusById(ship_id);
                                }
                            }
                        }
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);

                    if (this.shippingByRef) {
                        let ship_id = this.shippingByRef["Shifl Ref#"].substr(
                            1,
                            this.shippingByRef["Shifl Ref#"].length
                        );
                        this.getShipmentStatusById(ship_id);
                    }
                });
        },
    },
    computed: {},
    watch: {},
};
</script>

<style scoped></style>
